module.exports = __webpack_public_path__ + "img/checkbox-gray.0b86646.svg";